import { ReactNode } from "react";
import HeaderNavigation from "./header-navigation";

export default function SitePage({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <HeaderNavigation />
      <article className="prose mx-auto mt-16">{children}</article>
    </div>
  );
}
